(function() { window.GUID_97cd81c8_1303_4366_83bf_edfd1a92c222 = { getGuid: function() { return "97cd81c8-1303-4366-83bf-edfd1a92c222"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class FixedHeaderHelper {
            get HeaderIsVisible() {
                return (this.State.TopReached &&
                    !this.State.PreBottomReached &&
                    !this.State.DisappearedOnTop &&
                    !this.State.Desactivated);
            }
            constructor(parameters) {
                //Fait en sorte qu'on ne vera pratiquement jamais le loading affiché
                this.lazyLoadingMessageConsumedSpaceBuffer = 80;
                this.Log = false;
                this.State = {
                    Desactivated: false,
                    TopReached: false,
                    PreBottomReached: false,
                    DisappearedOnTop: false,
                };
                this.Id = parameters.Id;
                this.OnCloneHeader = parameters.OnCloneHeader;
                this.setElementReferences(parameters.$HeaderReference, parameters.$ContainerReference, parameters.$ContainerWithoutScrollBarReference);
                this.OnBeforeShowFixedHeader = parameters.OnBeforeShowFixedHeader;
                this.OnBeforeHideFixedHeader = parameters.OnBeforeHideFixedHeader;
                this.OnLazyLoaderTriggerReached = parameters.OnLazyLoaderTriggerReached;
                this.ResetLazyLoading();
            }
            setElementReferences($header, $container, $containerWithoutScrollBarReference = null) {
                let me = this;
                this.$headerRef = $header;
                this.$containerRef = $container;
                this.$containerRef.data("instance", this);
                this.$containerWithoutScrollBarReference =
                    $containerWithoutScrollBarReference;
                if (this.$containerRef.css("position") != "relative") {
                    this.$containerRef.css("position", "relative");
                }
            }
            PreCalculateLayoutForFixedHeaderPositionning() {
                let me = this;
                this.State.TopReached = false;
                this.State.PreBottomReached = false;
                this.State.DisappearedOnTop = false;
                this.State.Desactivated = false;
                //Previent une exception via le getBoundingClientRect en IE lorsque la taille est de 0
                if (me.$containerRef && me.$containerRef.length > 0 && me.$containerRef[0].clientHeight > 0) {
                    let containerRect = me.$containerRef[0].getBoundingClientRect();
                    let $searchBar = $(".app__search-bar").last();
                    let searchBarHeight = $searchBar.length > 0 ? $searchBar.outerHeight() : 0;
                    me.SectionTop =
                        containerRect.top + CS.DOM.$win.scrollTop() - searchBarHeight - 1;
                    me.HeaderHeight = me.$headerRef[0].getBoundingClientRect().height - 1;
                    me.SectionHeight = containerRect.height;
                    me.SectionWidth = containerRect.width;
                    me.SectionBottom = me.SectionHeight + me.SectionTop;
                    if (me.$containerWithoutScrollBarReference) {
                        let preBottomRect = me.$containerWithoutScrollBarReference[0].getBoundingClientRect();
                        let offset = me.SectionHeight - preBottomRect.height;
                        me.SectionPreBottom = me.SectionBottom - offset - me.HeaderHeight * 2;
                    }
                    else {
                        me.SectionPreBottom = me.SectionBottom - me.HeaderHeight * 2;
                    }
                }
                else {
                    me.SectionTop = 0;
                    me.HeaderHeight = 0;
                    me.SectionHeight = 0;
                    me.SectionWidth = 0;
                    me.SectionBottom = 0;
                    me.SectionPreBottom = 0;
                }
                me.HeaderTopPreBottomMode =
                    me.SectionHeight - (me.SectionBottom - me.SectionPreBottom);
            }
            AnalyseCurrentState(top, bottom, nextHeaderTop) {
                const me = this;
                let sectionTop = me.SectionTop;
                let sectionBottom = me.SectionBottom;
                const isStatsWall = $(".controller-statswall").length > 0;
                const isStatsWallV2 = $(".controller-statswallv2").length > 0;
                if (isStatsWallV2) {
                    const $stickyTopElement = $(".stats-walls-v2-sticky-top-main-element");
                    if ($stickyTopElement.length &&
                        $stickyTopElement.css("position") === "sticky") {
                        top += $stickyTopElement.outerHeight();
                    }
                    const $accordionContainer = this.$containerRef.closest(".accordion-container");
                    if ($accordionContainer.length) {
                        const $header = $accordionContainer.find(".main-wall-section-header");
                        if ($header.length && !$header.hasClass("no-sticky-header")) {
                            top += $header.outerHeight() - 1;
                        }
                    }
                }
                if (isStatsWall) {
                    const $chips = $(".chips.filter-chips");
                    const $tabs = $("#stats-sub-nav-buttons");
                    let _top = 0;
                    let _bottom = 0;
                    if ($chips.length) {
                        _top += $chips.outerHeight();
                        _bottom += $chips.outerHeight();
                    }
                    //if ($tabs.length) {
                    //    _top += $tabs.outerHeight();
                    //    _bottom += $tabs.outerHeight();
                    //}
                    const $accordionContainer = this.$containerRef.closest(".accordion-container");
                    if ($accordionContainer.length) {
                        const $header = $accordionContainer.find(".main-wall-section-header");
                        if ($header.length) {
                            _top += $header.outerHeight() - 1;
                            _bottom += $header.outerHeight() - 1;
                        }
                    }
                    const $statsGroupsContainer = this.$containerRef.closest(".stat-group-sections.with-header");
                    if ($statsGroupsContainer.length) {
                        const $statsGroupsHeader = $statsGroupsContainer.find(".stat-group-sections__header");
                        if ($statsGroupsHeader.length) {
                            _top += $statsGroupsHeader.outerHeight();
                            _bottom += $statsGroupsHeader.outerHeight();
                        }
                    }
                    sectionTop -= _top;
                    sectionBottom -= _bottom + 50;
                }
                let disappearedOnTop = sectionBottom - top <= 0;
                let preBottomReached = this.SectionPreBottom - top <= 0 && !disappearedOnTop;
                let topReached = sectionTop - top <= 0 && !preBottomReached && !disappearedOnTop;
                let desactivated = (!topReached && !preBottomReached) || disappearedOnTop;
                if (!desactivated &&
                    this.SectionBottom - this.lazyLoadingMessageConsumedSpaceBuffer <=
                        bottom &&
                    topReached) {
                    this.checkIfLazyLoad();
                }
                //le commentaire au bout de ce if etait la pour faire en sorte que un fix header ne fonctionne pas si la section est plus petite que la moitié
                //de l'écran mais je vais devoir trouver mieux parce que ca l'affectait le grid
                if (sectionTop == sectionBottom ||
                    this.SectionHeight <= this.HeaderHeight * 2) {
                    disappearedOnTop = false;
                    preBottomReached = false;
                    topReached = false;
                    topReached = false;
                    desactivated = true;
                }
                if (disappearedOnTop && !this.State.DisappearedOnTop) {
                    this.State.TopReached = false;
                    this.State.PreBottomReached = false;
                    this.State.DisappearedOnTop = true;
                    this.State.Desactivated = true;
                    if (this.Log) {
                        CS.Helper.log('fixed header', "disappeared on top");
                    }
                    this.removeFixedHeader();
                }
                else if (preBottomReached && !this.State.PreBottomReached) {
                    this.State.TopReached = false;
                    this.State.PreBottomReached = true;
                    this.State.DisappearedOnTop = false;
                    this.State.Desactivated = false;
                    if (this.Log) {
                        CS.Helper.log('fixed header', "pre bottom reached");
                    }
                    this.activateScrollingOfTheFixedHeader(nextHeaderTop);
                }
                else if (topReached && !this.State.TopReached) {
                    this.State.TopReached = true;
                    this.State.PreBottomReached = false;
                    this.State.DisappearedOnTop = false;
                    this.State.Desactivated = false;
                    if (this.Log) {
                        CS.Helper.log('fixed header', "top reached");
                    }
                    this.showFixedHeader(nextHeaderTop);
                    this.OnAfterShowFixedHeader();
                }
                else if (desactivated && !this.State.Desactivated) {
                    this.State.TopReached = false;
                    this.State.PreBottomReached = false;
                    this.State.DisappearedOnTop = false;
                    this.State.Desactivated = true;
                    if (this.Log) {
                        CS.Helper.log('fixed header', "not activated");
                    }
                    this.removeFixedHeader();
                }
                if (this.HeaderIsVisible) {
                    return this.HeaderHeight;
                }
                else {
                    return 0;
                }
            }
            showFixedHeader(top) {
                const isMatchesWall = $(".controller-matcheswall").length > 0;
                if (isMatchesWall) {
                    const $accordion = $(".accordion-matches-v2");
                    if ($accordion.length) {
                        const $chips = $accordion.find(".chips");
                        if ($chips.length) {
                            top += $chips.outerHeight();
                        }
                    }
                }
                const isStatsWallV2 = $(".controller-statswallv2").length > 0;
                if (isStatsWallV2) {
                    top = CS.Views.MasterPage.TopHeight - 2;
                    const $accordionContainer = this.$containerRef.closest(".accordion-container");
                    if ($accordionContainer.length) {
                        const $header = $accordionContainer.find(".main-wall-section-header");
                        if ($header.length && !$header.hasClass("no-sticky-header")) {
                            top += $header.outerHeight() - 1;
                        }
                    }
                    const $stickyTopElement = $(".stats-walls-v2-sticky-top-main-element");
                    if ($stickyTopElement.length &&
                        $stickyTopElement.css("position") === "sticky") {
                        top += $stickyTopElement.outerHeight();
                    }
                }
                else {
                    top -= 1;
                }
                if (this.OnBeforeShowFixedHeader) {
                    this.OnBeforeShowFixedHeader();
                }
                if (!this.$FixedHeader) {
                    this.$FixedHeaderContent = this.OnCloneHeader();
                    this.$FixedHeader = $('<div class="fixed-header-helper"></div>');
                    this.$FixedHeader.append(this.$FixedHeaderContent);
                    this.$FixedHeader.appendTo(this.$containerRef);
                }
                this.$FixedHeaderContent.css({
                    "margin-top": 0,
                });
                this.$FixedHeader.css({
                    position: "fixed",
                    "z-index": 5,
                    top: top,
                    height: this.HeaderHeight,
                    width: this.SectionWidth,
                    overflow: "hidden",
                });
            }
            activateScrollingOfTheFixedHeader(top) {
                this.showFixedHeader(top);
                this.$FixedHeader.css({
                    position: "absolute",
                    top: this.HeaderTopPreBottomMode,
                    height: this.HeaderHeight,
                });
            }
            removeFixedHeader() {
                if (this.$FixedHeader) {
                    if (this.OnBeforeHideFixedHeader) {
                        this.OnBeforeHideFixedHeader();
                    }
                    this.$FixedHeader.remove();
                    this.$FixedHeader = null;
                }
            }
            ResetLazyLoading() {
                let me = this;
                this.stopTrackingLazyLoaderTrigger = false;
            }
            Dispose() { }
            checkIfLazyLoad() {
                let me = this;
                if (!me.stopTrackingLazyLoaderTrigger) {
                    me.stopTrackingLazyLoaderTrigger = true;
                    let $lazyLoaderTrigger = me.getLazyLoadingTrigger();
                    if ($lazyLoaderTrigger) {
                        if (me.OnLazyLoaderTriggerReached) {
                            me.TriggerLazyLoading($lazyLoaderTrigger);
                        }
                    }
                }
            }
            TriggerLazyLoading($lazyLoaderTrigger) {
                let me = this;
                let data = {
                    SkipQuantity: $lazyLoaderTrigger.data("skipquantity"),
                };
                me.OnLazyLoaderTriggerReached(data, (containLazyTrigger) => {
                    $lazyLoaderTrigger.remove();
                    if (containLazyTrigger) {
                        /*Evite un lazy loading trop rapide entre 2 batchs*/
                        CS.Lag("lazy-loading-lag", 500, function () {
                            me.stopTrackingLazyLoaderTrigger = false;
                        });
                    }
                });
            }
            getLazyLoadingTrigger() {
                let $lazyLoaderTrigger = this.$containerRef.find(FixedHeaderHelper.FixedheaderTriggerName);
                let fixedHeader = this.getLazyLoaderTriggerParent($lazyLoaderTrigger);
                if (fixedHeader == this) {
                    return $lazyLoaderTrigger;
                }
                else {
                    return null;
                }
            }
            getLazyLoaderTriggerParent($child) {
                let $parent = $child.parent();
                if ($parent.length > 0) {
                    let fixedHeaderParent = $parent.data("instance");
                    if (fixedHeaderParent) {
                        return fixedHeaderParent;
                    }
                    else {
                        return this.getLazyLoaderTriggerParent($parent);
                    }
                }
                else
                    return null;
            }
        }
        Controls.FixedHeaderHelper = FixedHeaderHelper;
        (function (FixedHeaderHelper) {
            FixedHeaderHelper.FixedheaderTriggerName = ".lazy-loader-trigger";
        })(FixedHeaderHelper = Controls.FixedHeaderHelper || (Controls.FixedHeaderHelper = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=fixed-header-helper.js.map
